'use client';
import { RequireRole } from '../../components/console-shell';
import { VerificationWorkspace } from '../../components/desk/verification-workspace';
import { useSession } from '../../lib/session';
export default function VerificationPage() {
  const { hasRole } = useSession();
  const role = ['PROFILE_CASE_HANDLER', 'PROFILE_CASE_REVIEWER', 'ORGANIZATION_ADMIN', 'GRASSROOTS_INFO_COORDINATOR'].find(hasRole) ?? 'PROFILE_CASE_HANDLER';
  return <RequireRole roleCode={role}><VerificationWorkspace /></RequireRole>;
}
